import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { setLocale } from 'yup'
import styled from 'styled-components'

import Loader from 'atoms/Loader'

import GraphqlApiErrorModal from 'modals/GraphqlApiErrorModal'

import WarningModal from 'modals/WarningModal'

import { Vehicle } from 'pages/Vehicle'
import VehicleCalculator from 'pages/Vehicle/VehicleCalculator'

import { hv_tco_data } from 'pages/Vehicle/helpers/hv_Data'

setLocale({
  number: {
    moreThan: ({ more }: { more: number }) => `value must be greater than ${more}`,
  },
})

const Routes = () => {
  const local_vehicle_data = JSON.parse(localStorage.getItem('hv_data') || '[]')

  if (!local_vehicle_data || !local_vehicle_data.length)
    localStorage.setItem('hv_data', JSON.stringify(hv_tco_data))

  return (
    <React.Suspense fallback={<Loader />}>
      <StyledRoot>
        <Switch>
          <Route exact path="/" component={() => <Vehicle />} />
          <Route exact path="/vehicle-calculator" component={() => <VehicleCalculator />} />
        </Switch>
      </StyledRoot>
      <GraphqlApiErrorModal />
      <WarningModal />
    </React.Suspense>
  )
}
export default Routes

const StyledRoot = styled.div`
  padding: 10px 10px;
  max-width: 1380px;
  margin: 0 auto;
  box-sizing: border-box;
`
